'use strict';

const AuthenticationType = {
    User: { value: "User" },
    Sso: { value: "Sso" },
    Password: { value: "Password" }
};

export default AuthenticationType;

